// formatNotificationDate es el mismo formato que ya usaba HeaderCollapsible.vue
// antes de extraer NotificationBell.vue — compartido con la página de
// historial (views/notifications/Notifications.vue) para no duplicarlo.
export function formatNotificationDate(value) {
  if (!value) return "";
  return new Intl.DateTimeFormat("es-CL", {
    day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
  }).format(new Date(value));
}
